import { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, IconButton, SwipeableDrawer, useMediaQuery, classes } from 'bonfire-kindling';

import {
  ResponsiveSideNavContainerProvider,
  ResponsiveSideNavContainerContext,
} from './ResponsiveSideNavContainerProvider';

const ResponsiveSideNavContainerContent = ({ children }) => {
  const { t } = useTranslation();
  const { setIsDrawerOpen } = useContext(ResponsiveSideNavContainerContext);

  return (
    <>
      <IconButton
        iconName="times"
        aria-label={t('settings.close_drawer')}
        onClick={() => setIsDrawerOpen(false)}
        sx={{
          display: { sm: 'none' },
          width: 'max-content',
          ml: 'auto',
          mr: theme => theme.spacing(2),
          my: theme => theme.spacing(2),
        }}
        borderless
      />
      {children}
    </>
  );
};

const ResponsiveSideNavContainer = ({ children }) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <ResponsiveSideNavContainerProvider setIsDrawerOpen={setIsDrawerOpen}>
      <Box
        sx={{
          display: { xs: 'flex', sm: 'none' },
          justifyContent: 'flex-end',
          mb: theme => theme.spacing(5),
        }}
      >
        <IconButton
          iconName="bars"
          aria-label={t('settings.open_drawer')}
          onClick={() => setIsDrawerOpen(prev => !prev)}
          borderless
        />
      </Box>
      <Box sx={{ width: theme => ({ sm: theme.widths.sideNav }), flexShrink: { sm: 0 } }}>
        <SwipeableDrawer
          anchor="left"
          variant={isMobile ? 'temporary' : 'permanent'}
          open={isMobile ? isDrawerOpen : true}
          onOpen={() => setIsDrawerOpen(true)}
          onClose={() => setIsDrawerOpen(false)}
          hideBackdrop={isMobile}
          keepMounted={isMobile}
          sx={{
            display: 'block',
            [`& .${classes.components.MuiDrawer.paper}`]: {
              boxSizing: 'border-box',
              width: theme => theme.widths.sideNav,
              overflowX: 'hidden',
              pt: theme => `calc(${theme.mixins.toolbar.minHeight}px + 2px)`,
            },
          }}
        >
          {children}
        </SwipeableDrawer>
      </Box>
    </ResponsiveSideNavContainerProvider>
  );
};

ResponsiveSideNavContainer.Content = ResponsiveSideNavContainerContent;

export default ResponsiveSideNavContainer;
